<template v-if="locale.interimBilling">
  <div class="billing" id="billing">
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
      <h1>{{locale.billing.interimBilling}}</h1>
    </div>
    <p>{{locale.billing.interimPrice}}: {{interimBillingSummary.total}}</p>
    <div class="table-responsive">
      <table class="responsive">
        <thead>
        <tr>
            <th scope="col">{{locale.billing.service}}</th>
            <th scope="col">{{locale.billing.name}}</th>
            <th scope="col">{{locale.billing.price}}</th>
        </tr>
        </thead>
        <tbody>
          <template v-for="billingItem in interimBillingItemList">
            <tr :key="billingItem.price + billingItem.name">
              <td data-label="Data">
                  {{billingItem.service}}
              </td>
              <td data-label="Data">
                  {{billingItem.name}}
              </td>
              <td data-label="Data">
                  {{billingItem.price}}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InterimBilling',
  computed: {
    ...mapState(['locale']),
    ...mapState({
      interimBillingItemList: state => state.billing.interimBillingItemList,
      interimBillingSummary: state => state.billing.interimBillingSummary,
      loadingState: state => state.loadingState
    })
  },
  mounted () {
    this.$store.dispatch('billing/getInterimBilling')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InterimBilling.vue